var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"meichu2024"}},[_c('MobileNav'),_c('div',{staticClass:"main"},[_c('Nav')],1),_c('router-view'),_c('footer',[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }